import { Link } from 'react-router-dom';

export default function HeroSection() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 100);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="relative w-full h-screen min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Epic%20sports%20stadium%20panorama%20at%20golden%20hour%2C%20dramatic%20sky%20with%20warm%20orange%20and%20crimson%20clouds%2C%20massive%20illuminated%20arena%20with%20thousands%20of%20lights%2C%20cinematic%20wide%20angle%20composition%2C%20atmospheric%20and%20grandiose%2C%20professional%20sports%20photography%20aesthetic%2C%20warm%20golden%20and%20deep%20red%20color%20palette%2C%20epic%20scale%20and%20majestic%20feeling&width=1920&height=1080&seq=hero-kaiyuan-sports&orientation=landscape"
        alt="开元体育 - 专业体育娱乐平台"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>

      <div className="relative z-10 w-full text-center px-4 md:px-6 max-w-5xl mx-auto">
        <div className="mb-6">
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent-500/20 backdrop-blur-sm border border-accent-400/30 text-accent-200 text-sm font-medium">
            <i className="ri-sparkling-line"></i>
            2026新赛季 · 精彩不断
          </span>
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6">
          专业体育娱乐平台
          <br />
          <span className="text-accent-400">尽享全球精彩赛事</span>
        </h1>

        <p className="text-lg md:text-xl text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          汇聚全球顶级赛事资讯、实时数据与专业分析，开元体育为广大体育爱好者提供流畅、安全、多元的在线体育体验
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-full text-base transition-all duration-300 whitespace-nowrap"
          >
            立即注册
            <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="#categories"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white font-medium rounded-full text-base transition-all duration-300 border border-white/20 whitespace-nowrap"
          >
            探索赛事
            <i className="ri-arrow-down-line"></i>
          </Link>
        </div>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl mx-auto">
          {[
            { num: '30+', label: '体育项目' },
            { num: '200+', label: '覆盖国家' },
            { num: '100万+', label: '活跃用户' },
            { num: '7×24', label: '在线客服' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-accent-400 font-[Oswald]">
                {stat.num}
              </div>
              <div className="text-xs md:text-sm text-white/60 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div className={`absolute bottom-8 left-1/2 -translate-x-1/2 transition-opacity duration-500 ${scrolled ? 'opacity-0' : 'opacity-100'}`}>
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex items-start justify-center p-1.5">
          <div className="w-1.5 h-3 bg-white/60 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}